// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let ImageGridImage = require("./ImageGridImage.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ImageGrid_image_graphql = require("../../../__generated__/ImageGrid_image_graphql.bs.js");

let convertFragment = ImageGrid_image_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ImageGrid_image_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ImageGrid_image_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ImageGrid_image_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ImageGrid_image_graphql.node, convertFragment, fRef);
}

let ImageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ImageGrid(props) {
  let onSelectImage = props.onSelectImage;
  let labels = props.labels;
  let images = RescriptRelay_Fragment.useFragment(ImageGrid_image_graphql.node, convertFragment, props.images);
  let imageCount = images.length;
  let tmp;
  if (imageCount > 0) {
    let tmp$1;
    let exit = 0;
    let len = images.length;
    if (len >= 3) {
      exit = 1;
    } else {
      switch (len) {
        case 0 :
          exit = 1;
          break;
        case 1 :
          let img = images[0];
          tmp$1 = JsxRuntime.jsx(ImageGridImage.make, {
            image: img.fragmentRefs,
            index: 0,
            imageVariant: "large",
            onPress: extra => onSelectImage(0)
          });
          break;
        case 2 :
          let img1 = images[0];
          let img2 = images[1];
          tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(ImageGridImage.make, {
                image: img1.fragmentRefs,
                index: 0,
                imageVariant: "medium",
                onPress: extra => onSelectImage(0),
                className: "col-start-1 col-end-2"
              }),
              JsxRuntime.jsx(ImageGridImage.make, {
                image: img2.fragmentRefs,
                index: 1,
                imageVariant: "medium",
                onPress: extra => onSelectImage(1),
                className: "col-start-2 col-end-3"
              })
            ]
          });
          break;
      }
    }
    if (exit === 1) {
      let match = images.slice(0, 3);
      if (match.length !== 3) {
        tmp$1 = null;
      } else {
        let img1$1 = match[0];
        let img2$1 = match[1];
        let img3 = match[2];
        tmp$1 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(ImageGridImage.make, {
              image: img1$1.fragmentRefs,
              index: 0,
              imageVariant: "medium",
              onPress: extra => onSelectImage(0),
              className: "col-start-1 col-end-3 row-start-1 row-end-3"
            }),
            JsxRuntime.jsx(ImageGridImage.make, {
              image: img2$1.fragmentRefs,
              index: 1,
              imageVariant: "small",
              onPress: extra => onSelectImage(1),
              className: "col-start-3 col-end-4 row-start-1 row-end-2"
            }),
            JsxRuntime.jsx(ImageGridImage.make, {
              image: img3.fragmentRefs,
              index: 2,
              imageVariant: "small",
              onPress: extra => onSelectImage(2),
              className: "col-start-3 col-end-4 row-start-2 row-end-3"
            })
          ]
        });
      }
    }
    tmp = JsxRuntime.jsx("div", {
      children: tmp$1,
      className: imageCount !== 1 ? (
          imageCount !== 2 ? "grid grid-cols-3 grid-rows-2 gap-2" : "grid grid-cols-2 gap-2"
        ) : "flex"
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      labels !== undefined ? JsxRuntime.jsx("div", {
          children: labels,
          className: "absolute top-2 left-2 z-20"
        }) : null,
      images.length > 3 ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("button", {
            children: JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(IconV5.make, {
                  icon: "picture",
                  size: 16
                }),
                JsxRuntime.jsx("div", {
                  children: "View all photos"
                })
              ],
              className: "flex items-center gap-2"
            }),
            className: "bg-white text-gray-700 p-1.5 rounded cursor-pointer text-base font-medium",
            onClick: props.onViewAll
          }),
          className: "absolute bottom-2 right-2 z-20"
        }) : null,
      tmp
    ],
    className: "relative"
  });
}

let make = ImageGrid;

exports.ImageFragment = ImageFragment;
exports.make = make;
/* IconV5 Not a pure module */
